import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
   apiKey: "AIzaSyCZqCXF7720O7iqa0gKzb0uib8p7hD-NyY",
   authDomain: "tchat-4367b.firebaseapp.com",
   projectId: "tchat-4367b",
   storageBucket: "tchat-4367b.appspot.com",
   messagingSenderId: "557795552607",
   appId: "1:557795552607:web:f1905f6592a23da66e9aea"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();